import React from "react";
import { Box, Tooltip } from "@mui/material";
import { SvgIcon } from "@mui/material";
import { MonitorPlatform } from "../types";

// Reddit icon SVG
const RedditIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
    </svg>
  </SvgIcon>
);

// Hacker News Y Combinator icon
const HackerNewsIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M0 0v24h24V0H0zm12.3 13.27V18.9h-.6v-5.63L8.12 6.92h.7l3.18 5.6 3.18-5.6h.7l-3.58 6.35z" />
    </svg>
  </SvgIcon>
);

// LinkedIn icon
const LinkedInIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  </SvgIcon>
);

// X (Twitter) icon
const XIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  </SvgIcon>
);

// Google AI icon
const GoogleAIIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  </SvgIcon>
);

// ChatGPT icon
const ChatGPTIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
    </svg>
  </SvgIcon>
);

// Quora icon
const QuoraIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <SvgIcon sx={{ fontSize: size }}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.738 18.394c-.723-1.208-1.533-2.455-2.882-2.455-.378 0-.756.094-1.1.321l-.555-.844c.562-.555 1.597-1.038 2.823-1.038 1.806 0 2.931.933 3.857 2.211.344-1.135.52-2.455.52-3.908 0-5.006-1.865-7.827-5.478-7.827-3.596 0-5.478 2.821-5.478 7.827 0 4.977 1.882 7.778 5.478 7.778.723 0 1.38-.113 1.982-.336.176.285.353.555.546.808.59.781 1.266 1.37 2.353 1.37.377 0 .764-.09 1.101-.269v-1.515c-.168.047-.328.067-.495.067-.438 0-.78-.202-1.102-.59-.336-.404-.672-.93-1.08-1.514l-.49-.086zM12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12zm-.004 19.462c-4.786 0-7.394-3.362-7.394-9.462 0-6.098 2.608-9.462 7.394-9.462 4.804 0 7.394 3.364 7.394 9.462 0 6.1-2.59 9.462-7.394 9.462z" />
    </svg>
  </SvgIcon>
);

interface PlatformIconProps {
  platform: MonitorPlatform;
  size?: number;
  showLabel?: boolean;
}

const PlatformIcon: React.FC<PlatformIconProps> = ({
  platform,
  size = 24,
  showLabel = false,
}) => {
  const platformConfig: Record<
    MonitorPlatform,
    { icon: React.ReactNode; label: string; color: string }
  > = {
    reddit: {
      icon: <RedditIcon size={size} />,
      label: "Reddit",
      color: "#FF4500",
    },
    hackernews: {
      icon: <HackerNewsIcon size={size} />,
      label: "Hacker News",
      color: "#FF6600",
    },
    linkedin: {
      icon: <LinkedInIcon size={size} />,
      label: "LinkedIn",
      color: "#0A66C2",
    },
    x: {
      icon: <XIcon size={size} />,
      label: "X (Twitter)",
      color: "#000000",
    },
    quora: {
      icon: <QuoraIcon size={size} />,
      label: "Quora",
      color: "#B92B27",
    },
    chatgpt: {
      icon: <ChatGPTIcon size={size} />,
      label: "ChatGPT",
      color: "#10A37F",
    },
    google_ai: {
      icon: <GoogleAIIcon size={size} />,
      label: "Google AI",
      color: "#4285F4",
    },
  };

  const config = platformConfig[platform];

  if (!config) {
    return null;
  }

  return (
    <Tooltip title={config.label}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: config.color,
        }}
      >
        {config.icon}
        {showLabel && (
          <Box component="span" sx={{ fontSize: "0.875rem" }}>
            {config.label}
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default PlatformIcon;
